import additionalSalesDefaultState from './additionalSalesDefaultState'

export const getZohoId = model => {
  return model?.zoho_contract_detail_id || ''
}

const mapAdditionalSalesData = viewParameters => {
  const currentSubscriber = viewParameters.current_subscriber
  return {
    ...additionalSalesDefaultState,
    leadVerisureTelecom: getZohoIdAndProductId(currentSubscriber?.sale_verisure_telecom),
    leadAssistance: retrieveAssistanceData(currentSubscriber),
    leadCarbonOffset: retrieveCarbonOffsetData(currentSubscriber),
    leadTelecomEnergy: mapGenericLeadWithCallback(currentSubscriber?.sale_telecom_energy),
    leadTelecomSat: mapGenericLeadWithCallback(currentSubscriber?.sale_telecom_sat),
    leadProtected: retrieveProtectedData(currentSubscriber),
    leadProtectedClub: retrieveProtectedClubData(currentSubscriber),
    leadAssurance: getZohoIdAndProductId(currentSubscriber?.sale_assurance),
    leadAssuranceDefault: retrieveAssuranceDefaultData(currentSubscriber?.sale_assurance_default),
    leadAssuranceEmprunteur: simpleLeadTypeAndZohoIdMapping(currentSubscriber?.sale_assurance_emprunteur),
    leadOffshoreTelecom: retrieveLeadOffshoreData(currentSubscriber?.sale_offshore_telecom),
    leadPartnership: mapGenericLeadWithCallback(currentSubscriber?.sale_partnership),
    leadTelecom: retrieveLeadTelecomData(currentSubscriber),
    leadTelecomLovys: retrieveLeadTelecomLovysData(currentSubscriber),
    leadBankinAssurance: retrieveLeadBankinAssuranceData(currentSubscriber),
    leadMonConseillerPerso: retrieveMonConseillerPersoData(currentSubscriber),
    leadProxiserve: simpleZohoIdMapping(currentSubscriber?.sale_boiler_proxiserve),
    leadGaranka: retrieveGarankaData(currentSubscriber),
    leadVerisure: simpleZohoIdMapping(currentSubscriber?.sale_verisure),
    leadAccessoriesSfr: retrieveAccessoriesSfrData(currentSubscriber),
    leadGroupPurchaseTelecom: simpleZohoIdMapping(currentSubscriber?.sale_group_purchase_telecom),
    leadAssistancePro: simpleZohoIdMapping(currentSubscriber?.sale_assistance_pro),
    leadFloraAssuranceEthias: simpleLeadTypeAndZohoIdMappingNewStructure(
      currentSubscriber?.sale_flora_assurance_ethias,
    ),
    leadEddyProprietaire: simpleZohoIdMapping(currentSubscriber?.sale_eddy_proprietaire),
    leadFloraAssuranceLead: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_flora_assurance_lead),
    leadYagoAssuranceHouse: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_yago_assurance_house),
    leadYagoAssuranceCar: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_yago_assurance_car),
    leadYagoAssuranceMoto: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_yago_assurance_moto),
    leadSantevetAssurance: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_sante_vet_assurance),
    leadEthias: simpleZohoIdMapping(currentSubscriber?.sale_ethias),
    leadElite: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_elite),
    leadEngieBrussels: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_engie_brussels),
    leadVerisureTelecomBe: verisureTelecomBeMapping(currentSubscriber?.sale_verisure_be),
    leadBoilerEneco: retrieveBoilerWithOrderNumberData(currentSubscriber?.sale_boiler_eneco),
    leadBoilerEngie: retrieveBoilerWithOrderNumberData(currentSubscriber?.sale_boiler_engie),
    leadBoilerHomeserve: simpleLeadTypeAndZohoIdMappingNewStructure(currentSubscriber?.sale_boiler_homeserve),
    leadMesAllocs: simpleZohoIdMapping(currentSubscriber?.sale_administrative_service),
    leadWater: interactionData(currentSubscriber?.water_interaction ?? ''),
    leadTucoenergie: retrieveTucoenergieData(currentSubscriber),
    leadEnergygo: retrieveEnergygoData(currentSubscriber),
    leadBankPanorabanques: simpleZohoIdMapping(currentSubscriber?.sale_bank_panorabanques),
    leadMovingNextories: retrieveNextoriesData(currentSubscriber),
    leadYouStock: simpleZohoIdMapping(currentSubscriber?.you_stock),
    leadAssurancePro: retrieveAssuranceProData(currentSubscriber),
    leadVoltalisBizdev: retrieveLeadVoltalisBizdevData(currentSubscriber),
    leadNeat: retrieveLeadNeatData(currentSubscriber),
    leadCentury21: retrieveLeadCentury21Data(currentSubscriber),
    leadEnergyProPlaceDesEnergies: retrieveLeadEnergyProPlaceDesEnergiesData(currentSubscriber),
    leadAxaSmartphone: getZohoIdAndProductId(currentSubscriber?.sale_axa_smartphone),
    leadHomyos: retrieveLeadHomyosData(currentSubscriber),
    leadAssuranceEmprunteurMeilleurTaux: getZohoIdAndProductId(
      currentSubscriber?.sale_assurance_emprunteur_meilleur_taux,
    ),
    leadMutuelleSantiane: simpleZohoIdMapping(currentSubscriber?.sale_mutuelle_santiane),
    leadYolo: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_yolo),
    leadTim: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_tim),
    leadIren: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_iren),
    leadFastWeb: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_fast_web),
    leadProtectedIt: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_protected_it),
    leadEdison: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_edison),
    leadEnel: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_enel),
    leadSorgenia: retrieveItalyAdditionalSaleData(currentSubscriber?.sale_sorgenia),
  }
}

export const getZohoIdAndProductId = sale => {
  if (!sale) {
    return {
      zohoId: '',
      productId: '',
    }
  }

  return {
    zohoId: getZohoId(sale),
    productId: sale.product?.id ?? sale.product_id ?? '',
  }
}

export const retrieveLeadHomyosData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_homyos),
    productId: currentSubscriber?.sale_homyos?.product_id ?? '',
    typeFormCreated: currentSubscriber?.sale_homyos?.attributes?.typeFormCreated ?? '',
  }
}

export const verisureTelecomBeMapping = currentSale => {
  return {
    ...simpleLeadTypeAndZohoIdMappingNewStructure(currentSale),
    orderNumber: currentSale?.attributes?.orderNumber ?? generateRandomOrderNumber(),
  }
}

export const generateRandomOrderNumber = () => {
  return Math.floor(Math.random() * 10000000000) + 1
}

export const retrieveLeadEnergyProPlaceDesEnergiesData = currentSubscriber => {
  let leadCallbackDate = ''
  let leadCallbackTime = ''
  if (currentSubscriber?.sale_energy_pro_place_des_energies?.callback) {
    ;[leadCallbackDate, leadCallbackTime] = currentSubscriber.sale_energy_pro_place_des_energies.callback.split(' ')
  }

  return {
    leadZohoId: getZohoId(currentSubscriber?.sale_energy_pro_place_des_energies),
    leadCommitmentEndDate: currentSubscriber?.sale_energy_pro_place_des_energies?.attributes?.commitmentEndDate ?? '',
    leadType: currentSubscriber?.sale_energy_pro_place_des_energies?.attributes?.leadType ?? '',
    leadSitesNumber: currentSubscriber?.sale_energy_pro_place_des_energies?.attributes?.sitesNumber ?? '',
    leadCurrentProvider: currentSubscriber?.sale_energy_pro_place_des_energies?.attributes?.currentProvider ?? '',
    leadDescription: currentSubscriber?.sale_energy_pro_place_des_energies?.description ?? '',
    errorPartnerSync: currentSubscriber?.sale_energy_pro_place_des_energies?.error_partner_sync ?? '',
    leadCallbackDate,
    leadCallbackTime,
  }
}

export const retrieveLeadVoltalisBizdevData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_voltalis_bizdev),
    customerAgreement: currentSubscriber?.sale_voltalis_bizdev?.attributes?.customerAgreement ?? '',
    recapAgreement: currentSubscriber?.sale_voltalis_bizdev?.attributes?.recapAgreement ?? '',
  }
}

export const retrieveLeadNeatData = currentSubscriber => {
  const zohoId = getZohoId(currentSubscriber?.sale_neat)

  return {
    zohoId,
    saleId: currentSubscriber?.sale_neat?.id ?? 0,
    hasContract: 'false',
    customerAcceptation: zohoId ? '1' : '',
    productId: currentSubscriber?.sale_neat?.product_id ?? '',
    partnerId: currentSubscriber?.sale_neat?.partner_id ?? '',
    statusCode: currentSubscriber?.sale_neat?.status_code,
    zohoContractDetailId: currentSubscriber?.sale_neat?.zoho_contract_detail_id || '',
    effectiveDate: currentSubscriber?.sale_neat?.attributes?.effectiveDate ?? '',
  }
}

export const retrieveLeadCentury21Data = currentSubscriber => {
  const zohoId = getZohoId(currentSubscriber?.sale_century21)

  return {
    zohoId,
    project: currentSubscriber?.sale_century21?.attributes?.project ?? '',
    alreadyEstimated: currentSubscriber?.sale_century21?.attributes?.alreadyEstimated ?? '',
    alreadyOnMarket: currentSubscriber?.sale_century21?.attributes?.alreadyOnMarket ?? '',
    onMarketSince: currentSubscriber?.sale_century21?.attributes?.onMarketSince ?? '',
    managedByAgency: currentSubscriber?.sale_century21?.attributes?.managedByAgency ?? '',
    agencyName: currentSubscriber?.sale_century21?.attributes?.agencyName ?? '',
    projectNotes: currentSubscriber?.sale_century21?.attributes?.projectNotes ?? '',
    propertyAddress: currentSubscriber?.sale_century21?.attributes?.propertyAddress ?? '',
    propertyArea: currentSubscriber?.sale_century21?.attributes?.propertyArea ?? '',
    landArea: currentSubscriber?.sale_century21?.attributes?.landArea ?? '',
    constructionYear: currentSubscriber?.sale_century21?.attributes?.constructionYear ?? '',
    propertyNotes: currentSubscriber?.sale_century21?.attributes?.propertyNotes ?? '',
    propertyType: currentSubscriber?.sale_century21?.attributes?.propertyType ?? '',
    saleId: currentSubscriber?.sale_century21?.id ?? 0,
    zohoContractDetailId: currentSubscriber?.sale_century21?.zoho_contract_detail_id || '',
  }
}

export const retrieveGarankaData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_boiler_garanka),
    offerId: currentSubscriber?.sale_boiler_garanka?.attributes?.garankaOfferId ?? '',
    customerAgreement: '',
    buildingType: '',
    buildingAge: '',
    boilerDisposition: '',
    boilerTechnology: '',
    boilerAge: '',
    boilerBrand: '',
  }
}

export const retrieveAssuranceProData = currentSubscriber => {
  let callBackDate = ''
  let callBackTime = ''
  if (currentSubscriber?.sale_assurance_pro?.callback) {
    ;[callBackDate, callBackTime] = currentSubscriber.sale_assurance_pro.callback.split(' ')
  }

  return {
    zohoId: getZohoId(currentSubscriber?.sale_assurance_pro),
    callbackDate: callBackDate,
    callbackTime: callBackTime,
  }
}

export const retrieveBoilerWithOrderNumberData = model => {
  if (!model) {
    return {
      zohoId: '',
      leadType: '',
      orderNumber: '',
    }
  }

  return {
    zohoId: getZohoId(model),
    leadType: model.product?.name ?? '',
    orderNumber: model.attributes?.orderNumber ?? '',
  }
}

export const retrieveNextoriesData = currentSubscriber => {
  return {
    departureCountry: currentSubscriber?.sale_moving_nextories?.attributes?.country ?? '',
    departureCity: currentSubscriber?.sale_moving_nextories?.attributes?.city ?? '',
    departureZipcode: currentSubscriber?.sale_moving_nextories?.attributes?.zipcode ?? '',
    earliestMovingDate: currentSubscriber?.sale_moving_nextories?.attributes?.earliestMovingDate ?? '',
    movingDescription: currentSubscriber?.sale_moving_nextories?.description ?? '',
    zohoId: getZohoId(currentSubscriber?.sale_moving_nextories),
    errorPartnerSync: currentSubscriber?.sale_moving_nextories?.error_partner_sync ?? '',
  }
}

export const simpleLeadTypeAndZohoIdMappingNewStructure = model => {
  if (!model) {
    return {
      zohoId: '',
      leadType: '',
    }
  }

  return {
    zohoId: getZohoId(model),
    leadType: model.product?.name ?? '',
  }
}

export const simpleLeadTypeAndZohoIdMapping = model => {
  if (!model) {
    return {
      zohoId: '',
      leadType: '',
    }
  }

  return {
    zohoId: getZohoId(model),
    leadType: model.lead_type ?? '',
  }
}

export const retrieveTucoenergieData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_tucoenergie),
    typeCivility: currentSubscriber?.sale_tucoenergie?.attributes?.typeCivility ?? '',
    typeOccupation: currentSubscriber?.sale_tucoenergie?.attributes?.typeOccupation ?? '',
    typeRequest: currentSubscriber?.sale_tucoenergie?.attributes?.typeRequest ?? '',
    leadStatus: currentSubscriber?.sale_tucoenergie?.status_code ?? '',
    errorPartnerSync: currentSubscriber?.sale_tucoenergie?.error_partner_sync ?? '',
  }
}

export const retrieveEnergygoData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_energygo),
    leadStatus: currentSubscriber?.sale_energygo?.status_code ?? '',
    errorPartnerSync: currentSubscriber?.sale_energygo?.error_partner_sync ?? '',
    typeBusiness: currentSubscriber?.sale_energygo?.attributes?.typeBusiness ?? '',
    typeRequest: currentSubscriber?.sale_energygo?.attributes?.typeRequest ?? '',
    acceptationRappelRenovation: currentSubscriber?.sale_energygo?.attributes?.consentPhrase ? '1' : '0',
  }
}

export const interactionData = zohoId => {
  return {
    zohoId: zohoId ?? '',
  }
}

export const simpleZohoIdMapping = model => {
  return {
    zohoId: getZohoId(model),
  }
}

export const retrieveMonConseillerPersoData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_mon_conseiller_perso),
    offer: currentSubscriber?.sale_mon_conseiller_perso?.product_id ?? '',
    statusCode: currentSubscriber?.sale_mon_conseiller_perso?.status_code ?? '',
    errorPartnerSync: currentSubscriber?.sale_mon_conseiller_perso?.error_partner_sync ?? '',
    partnerId: currentSubscriber?.sale_mon_conseiller_perso?.attributes?.partnerId ?? '',
    paymentDay: currentSubscriber?.sale_mon_conseiller_perso?.attributes?.paymentDay ?? '',
    email: currentSubscriber?.sale_mon_conseiller_perso?.attributes?.email ?? '',
  }
}

export const retrieveLeadTelecomData = currentSubscriber => {
  let callbackDate = ''
  let callbackTime = ''
  if (currentSubscriber?.sale_telecom?.callback) {
    ;[callbackDate, callbackTime] = currentSubscriber.sale_telecom.callback.split(' ')
  }
  return {
    ...mapGenericLeadWithCallback(currentSubscriber?.sale_telecom),
    type: currentSubscriber?.sale_telecom?.attributes?.lead_type ?? '',
    callbackDate: callbackDate ?? '',
    callbackTime: callbackTime ?? '',
    description: currentSubscriber?.sale_telecom?.description ?? '',
  }
}

export const retrieveLeadTelecomLovysData = currentSubscriber => {
  let callbackDate = ''
  let callbackTime = ''
  if (currentSubscriber?.sale_telecom_lovys?.callback) {
    ;[callbackDate, callbackTime] = currentSubscriber.sale_telecom_lovys.callback.split(' ')
  }
  return {
    ...mapGenericLeadWithCallback(currentSubscriber?.sale_telecom_lovys),
    type: currentSubscriber?.sale_telecom_lovys?.attributes?.lead_type ?? '',
    callbackDate: callbackDate ?? '',
    callbackTime: callbackTime ?? '',
    description: currentSubscriber?.sale_telecom_lovys?.description ?? '',
  }
}

export const retrieveLeadBankinAssuranceData = currentSubscriber => {
  return {
    ...mapGenericLeadWithCallback(currentSubscriber?.sale_bankin_assurance),
    type: currentSubscriber?.sale_bankin_assurance?.attributes?.leadType ?? '',
    description: currentSubscriber?.sale_bankin_assurance?.description ?? '',
  }
}

export const retrieveLeadOffshoreData = currentModel => {
  return {
    zohoId: getZohoId(currentModel),
    currentProvider: currentModel?.attributes?.current_provider ?? '',
  }
}

export const retrieveAssuranceDefaultData = currentModel => {
  let callBackDate = ''
  let callBackTime = ''
  if (currentModel?.callback) {
    ;[callBackDate, callBackTime] = currentModel.callback.split(' ')
  }
  return {
    zohoId: getZohoId(currentModel),
    professionalCategory: currentModel?.attributes?.professional_category ?? '',
    leadType: currentModel?.attributes?.lead_type ?? '',
    callbackDate: callBackDate,
    callbackTime: callBackTime,
    description: currentModel?.description ?? '',
    moreThanOneYearContract: currentModel?.attributes?.moreThanOneYearContract ?? '',
    saleTopics: currentModel?.attributes?.saleTopics ?? '',
  }
}

export const retrieveProtectedClubData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_protected_club),
    productId: currentSubscriber?.sale_protected_club?.product_id ?? '',
  }
}

export const retrieveProtectedData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_protected),
    invoiceFrequency: currentSubscriber?.sale_protected?.attributes?.invoiceFrequency ?? '',
    smsCode: currentSubscriber?.sale_protected?.attributes?.code ?? '',
    errorPartnerSync: currentSubscriber?.sale_protected?.error_partner_sync ?? '',
    productId: currentSubscriber?.sale_protected?.product_id ?? '',
    statusCode: currentSubscriber?.sale_protected?.status_code ?? null,
  }
}

export const retrieveAssistanceData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_assistance),
    zohoContractDetailId: currentSubscriber?.sale_assistance?.zoho_contract_detail_id || '',
    zohoContractId: currentSubscriber?.sale_assistance?.zoho_contract_id || '',
    assistanceId: currentSubscriber?.sale_assistance?.product_id ?? '',
    customerAcceptation: '',
    statusCode: currentSubscriber?.sale_assistance?.status_code,
    axaEmailAlreadySent: currentSubscriber?.sale_assistance?.attributes?.email_sent ?? false,
    delayActivation: currentSubscriber?.sale_assistance?.attributes?.delay_activation_at ?? '',
    language: currentSubscriber?.sale_assistance?.attributes?.language ?? null,
  }
}

export const retrieveCarbonOffsetData = currentSubscriber => {
  const zohoId = getZohoId(currentSubscriber?.sale_carbon_offset)
  return {
    zohoId,
    offsetId: currentSubscriber?.sale_carbon_offset?.product_id ?? '',
    customerAcceptation: zohoId ? '1' : '',
    statusCode: currentSubscriber?.sale_carbon_offset?.status_code,
    language: currentSubscriber?.sale_carbon_offset?.attributes?.language ?? null,
    zohoContractId: currentSubscriber?.sale_carbon_offset?.zoho_contract_id || '',
    zohoContractDetailId: currentSubscriber?.sale_carbon_offset?.zoho_contract_detail_id || '',
  }
}

export const retrieveAccessoriesSfrData = currentSubscriber => {
  return {
    zohoId: getZohoId(currentSubscriber?.sale_accessories_sfr),
    product: currentSubscriber?.sale_accessories_sfr?.attributes?.product ?? '',
    saleId: currentSubscriber?.sale_accessories_sfr?.attributes?.saleId ?? '',
    productId: currentSubscriber?.sale_accessories_sfr?.product_id ?? '',
  }
}

export const mapGenericLeadWithCallback = model => {
  if (!model) {
    return {
      zohoId: '',
      callbackDate: '',
      callbackTime: '',
      description: '',
    }
  }

  let callBackDate = ''
  let callBackTime = ''
  if (model.callback) {
    ;[callBackDate, callBackTime] = model.callback.split(' ')
  }
  return {
    zohoId: getZohoId(model),
    leadType: model.product?.name ?? '',
    callbackDate: callBackDate,
    callbackTime: callBackTime,
    description: model.description ?? '',
  }
}

export const retrieveItalyAdditionalSaleData = sale => {
  return {
    zohoId: getZohoId(sale),
    product: sale?.attributes?.product ?? '',
    saleId: sale?.attributes?.saleId ?? '',
    productId: sale?.product_id ?? '',
  }
}

export default mapAdditionalSalesData
